import { render, staticRenderFns } from "./AppUpdateSettings.vue?vue&type=template&id=d263b930&"
import script from "./AppUpdateSettings.vue?vue&type=script&lang=js&"
export * from "./AppUpdateSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports